import { materialsApi } from '@texas/api/endpoints/metadata/materialsApi';
import { qualitiesApi } from '@texas/api/endpoints/metadata/qualitiesApi';
import { techniquesApi } from '@texas/api/endpoints/metadata/techniquesApi';
import { treatmentsApi } from '@texas/api/endpoints/metadata/treatmentsApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useEffect } from 'react';

export function useCompositionData({ vdcSupport }: { vdcSupport: boolean }) {
  const {
    data: materials,
    refetch: refetchMaterials,
    loading: materialsLoading,
  } = useApiResource(materialsApi.getAll);

  const {
    data: qualities,
    refetch: refetchQualities,
    loading: qualitiesLoading,
  } = useApiResource(qualitiesApi.getAll);

  const {
    data: treatments,
    refetch: refetchTreatments,
    loading: treatmentsLoading,
  } = useApiResource(treatmentsApi.getAll);

  const {
    data: techniques,
    refetch: refetchTechniques,
    loading: techniquesLoading,
  } = useApiResource(techniquesApi.getAll);

  useEffect(() => {
    refetchQualities({
      sortBy: '',
      sortDesc: false,
      searchTerm: '',
      includeArchived: false,
      preciseIdFiltering: false,
      productGroupId: null,
      vdcSupport: vdcSupport,
    });
    refetchTechniques({
      vdcSupport: vdcSupport,
    });
    refetchMaterials();
    refetchTreatments({
      sortBy: '',
      sortDesc: false,
      searchTerm: '',
      includeArchived: false,
      preciseIdFiltering: false,
      productGroupId: null,
      vdcSupport: vdcSupport,
    });
  }, [
    refetchMaterials,
    refetchQualities,
    refetchTechniques,
    refetchTreatments,
    vdcSupport,
  ]);

  return {
    qualities,
    treatments,
    techniques,
    materials,
    materialsLoading,
    techniquesLoading,
    treatmentsLoading,
    qualitiesLoading,
  };
}
